import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';
import { buildDarkVenueHeatmapWidgetConfigSlice } from './config/configslice';
import { DarkVenueHeatmapState } from './DarkVenueHeatmapState';
import { DarkVenueHeatmapActionPayload } from './actions';

const { reducer: configReducer } = buildDarkVenueHeatmapWidgetConfigSlice();

const darkVenueHeatmapWidgetReducer = combineReducers<DarkVenueHeatmapState>({
    config: configReducer,
});

export const darkVenueHeatmapWidgetsReducer = createWidgetsReducer<
    DarkVenueHeatmapState,
    DarkVenueHeatmapActionPayload
>(WidgetType.DARK_VENUE_HEATMAP, darkVenueHeatmapWidgetReducer);
